export const MapSkeleton = () => {
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="h-8 w-48 animate-pulse rounded bg-gray-300" />
      <div className="h-10 w-32 animate-pulse rounded bg-gray-300" />
      <div className="h-4 w-64 animate-pulse rounded bg-gray-200" />
      <div className="h-[70vh] w-full max-w-4xl lg:max-w-5xl animate-pulse rounded bg-gray-200" />
    </div>
  );
};
